export default "__VITE_ASSET__DxWvbkar__"